var _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgGoogleForms = function SvgGoogleForms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.188 7 2.639.518L19 7l-4.813-5-.663 2.37.664 2.63Z",
    fill: "#56368A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.188 7V2H6.311C5.588 2 5 2.61 5 3.364v17.272C5 21.39 5.587 22 6.313 22h11.375c.725 0 1.312-.61 1.312-1.364V7h-4.813Z",
    fill: "#7248B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.719 16.432a.67.67 0 0 1-.656-.682.67.67 0 0 1 .656-.682.67.67 0 0 1 .656.682.67.67 0 0 1-.656.682Zm0-2.727a.67.67 0 0 1-.656-.682.67.67 0 0 1 .656-.682.67.67 0 0 1 .656.682.67.67 0 0 1-.656.682Zm0-2.728a.67.67 0 0 1-.656-.682.67.67 0 0 1 .656-.681.67.67 0 0 1 .656.681.67.67 0 0 1-.656.682Zm7.219 5.341h-5.47v-1.136h5.47v1.136Zm0-2.727h-5.47v-1.136h5.47v1.136Zm0-2.727h-5.47V9.727h5.47v1.137Z",
    fill: "#fff"
  })));
};

export default SvgGoogleForms;